import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import LogTemplate from '@/views/Log/components/template/template.vue'
import Log from '@/views/Log/models/log'

@Component({
    inheritAttrs: false,
    name: 'log-project',
    components: { LogTemplate },
})
export default class LogProject extends Mixins<MixinInterface>() {
    @Prop({ required: true }) log!: Log

    get customString() {
        switch (this.log.logEventName) {
            case 'projectHseContactIsPublicUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'projectHseDocumentIsPublicUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'projectCustomIdUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectBklrIdUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectAvatarFileIdUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectAddressUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectCurrencyUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectCoordinatesUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new']['latitude'] && this.log.payload['new']['longitude']
                        ? 'notNull(new)'
                        : 'isNull(new)'
                }`
            case 'projectEmergencyNumberUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectAgreementUrlUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectHseBoardDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectPublicHseBoardDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectModuleStatusUpdated':
                return `${this.log.logEventName}_${this.log.payload['new']}`
            case 'projectHseContactDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectHseDocumentDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'projectGroupCreated':
                return `${this.log.logEventName}_${
                    this.log.payload['copyOf'] ? 'notNull(copyOf)' : 'isNull(copyOf)'
                }`
            case 'dashboardIsDefaultUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'dashboardIsDefaultUpdatedDueToOtherSetAsDefault':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'isTrue(new)' : 'isFalse(new)'
                }`
            case 'dashboardDescriptionUpdated':
                return `${this.log.logEventName}_${
                    this.log.payload['new'] ? 'notNull(new)' : 'isNull(new)'
                }`
            case 'fileDownloaded':
                return `${this.log.logEventName}`
            default:
                return this.log.logEventName
        }
    }

    newAttachment: any = null
    oldAttachment: any = null
    attachment: any = null
    editorJS: any = null

    async created() {
        switch (this.log.logEventName) {
            case 'projectDescriptionUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'projectAvatarFileIdUpdated':
                if (this.log.new) {
                    this.attachment = {
                        fileId: this.log.new,
                        filename: null,
                    }
                }
                break
            case 'projectHseBoardDescriptionUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'projectPublicHseBoardDescriptionUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'projectPublicHseBoardDescriptionUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'projectHseContactDescriptionUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break
            case 'projectHseDocumentDescriptionUpdated':
                if (this.log.new) {
                    this.editorJS = {
                        newVal: this.log.new,
                        oldVal: this.log.old,
                    }
                }
                break

            case 'projectHseDocumentFileUpdated':
                if (this.log.new) {
                    this.newAttachment = {
                        fileId: this.log.new.id,
                        filename: this.log.new.filename,
                    }
                }
                if (this.log.old) {
                    this.oldAttachment = {
                        fileId: this.log.old.id,
                        filename: this.log.old.filename,
                    }
                }
                break
        }
    }
}
